import { Fragment } from "react";
import type {
  BlockFragment,
  TopTrackDetailFragment,
  CurrentlyPlayingTrackDetailFragment,
} from "@ihr-radioedit/inferno-webapi";
import { blockHaveAd } from "@inferno/renderer-shared-core";
import { MusicPageType } from "../../lib/catalog";
import { isTopTrackDetailFragmentList } from "../../lib/guards";
import { AdPosition } from "../Ad.component";
import { TAKE } from "./MusicPage.component";
import { MusicTrack } from "./MusicTrack.component";

export const TopTrackList = ({
  data,
  block,
}: {
  data: (TopTrackDetailFragment | CurrentlyPlayingTrackDetailFragment)[];
  block: BlockFragment;
}) => {
  if (!isTopTrackDetailFragmentList(data)) {
    return null;
  }
  const adBlockData = { value: { ...block.value } } as BlockFragment;
  const showAd = blockHaveAd(block.value.position);

  return (
    <ul className="component-track-list playlist-topsongs">
      {data.map((track, i) => {
        return (
          <Fragment key={i}>
            {showAd && i > 0 && i % TAKE === 0 ? (
              <li className="load-more-ad">
                <AdPosition block={adBlockData} batchId={`${track.trackId}-${Math.ceil(i / block.value.position)}`} />
              </li>
            ) : null}
            <li className="track-list-item" key={i}>
              <MusicTrack track={track} type={MusicPageType.TOP} />
            </li>
          </Fragment>
        );
      })}
    </ul>
  );
};

export default TopTrackList;
